<template>
    <div class="content-wrapper" :class="[(comboActive ? 'comboActive' : ''), 'avgOdds' + avgOdds]">
        <div class="row">
            <app-breadcrumb :page-title="sport" :directory="$t('datatables')" :icon="'grid'" class="col-6"/>
            <div class="col-6 d-flex flex-row justify-content-end align-items-center">
                <label for="combo_switch" class="mr-2">{{ $t('combos') }}</label>
                <app-input id="combo_switch" type="switch" :label="$t('Switch')" v-model="comboActive"
                           @click="saveComboStatus"/>

                <label for="avg_odds" class="mr-2">{{ $t('avg_odds') }}</label>
                <select
                    id="avg_odds"
                    class="form-control"
                    style="max-width: 70px; height: 40px;"
                    v-model="avgOdds"
                    @change="saveAvgOdds"
                >
                    <option v-for="option in avgOddsOptions"
                            :key="option.value"
                            :value="option.value">
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="mb-primary col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h5 class="mb-3 d-none">{{ $t('filters') }}</h5>

                <app-table
                    :id="'sports-filter-table'"
                    :options="options"
                    @action="getAction"
                    @download-data="downloadData"
                    />

                <!--large modal start-->
                <app-modal v-if="createAlertModal"
                           modal-id="create-alert-modal"
                           modal-alignment="center"
                           modal-size="extra-large"
                           modal-header-class="mb-0 pb-0"
                           @confirmed="saveCreateAlert"
                           @close-modal="closeModal">
                    <template slot="header">
                        <div class="w-100">
                            <h5 class="modal-title">{{ selectedRow.name }}</h5>
                            <h6>{{ $t(selectedRow.sport) }}</h6>
                            <template v-if="!alertConfigureUpdates">
                                <h6 class="text-center" style="padding-left:50px;">
                                    <a href="#" @click.prevent="alertConfigureUpdatesToggle">{{ $t('configure_updates') }}</a></h6>
                            </template>
                            <template v-else>
                                <h6 class="text-left"><a href="#" @click="alertConfigureUpdatesToggle">{{ $t('back') }}</a></h6>
                            </template>
                        </div>
                        <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                        <span>
                            <app-icon :name="'x'"></app-icon>
                        </span>
                        </button>
                    </template>
                    <template slot="body">
                        <form id="create-alert">
                            <template v-if="!alertConfigureUpdates">
                                <div>
                                    <div class="d-flex justify-content-center pb-2">{{ $t('wdw') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-3">
                                            <label for="wdw_1">
                                                {{ $t('home') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="wdw_1"
                                                    name="wdw[1]"
                                                    v-model="selectedConditions['wdw']['1']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="wdw_2">
                                                {{ $t('draw') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="wdw_2"
                                                    name="wdw[2]"
                                                    v-model="selectedConditions['wdw']['2']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="wdw_3">
                                                {{ $t('away') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="wdw_3"
                                                    name="wdw[3]"
                                                    v-model="selectedConditions['wdw']['3']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="wdw_s">
                                                {{ $t('stake') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="wdw_s"
                                                    name="wdw[s]"
                                                    v-model="selectedConditions['wdw']['s']"
                                                    class="form-control"
                                                    :placeholder="$t('min_stake')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    <div class="d-flex justify-content-center pb-2">{{ $t('asian_handicap') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-3">
                                            <label for="ah_1">
                                                {{ $t('line') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ah_1"
                                                    name="ah[1]"
                                                    v-model="selectedConditions['ah']['1']"
                                                    class="form-control"
                                                    :placeholder="$t('min_line')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ah_2">
                                                {{ $t('home') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ah_2"
                                                    name="ah[2]"
                                                    v-model="selectedConditions['ah']['2']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ah_3">
                                                {{ $t('away') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ah_3"
                                                    name="ah[3]"
                                                    v-model="selectedConditions['ah']['3']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ah_s">
                                                {{ $t('stake') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ah_s"
                                                    name="ah[s]"
                                                    v-model="selectedConditions['ah']['s']"
                                                    class="form-control"
                                                    :placeholder="$t('min_stake')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    <div class="d-flex justify-content-center pb-2">{{ $t('over_under') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-3">
                                            <label for="ou_1">
                                                {{ $t('line') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ou_1"
                                                    name="ou[1]"
                                                    v-model="selectedConditions['ou']['1']"
                                                    class="form-control"
                                                    :placeholder="$t('min_line')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ou_2">
                                                {{ $t('over') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ou_2"
                                                    name="ou[2]"
                                                    v-model="selectedConditions['ou']['2']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ou_3">
                                                {{ $t('under') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ou_3"
                                                    name="ou[3]"
                                                    v-model="selectedConditions['ou']['3']"
                                                    class="form-control"
                                                    :placeholder="$t('min_odds')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <label for="ou_s">
                                                {{ $t('stake') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    id="ou_s"
                                                    name="ou[s]"
                                                    v-model="selectedConditions['ou']['s']"
                                                    class="form-control"
                                                    :placeholder="$t('min_stake')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div>
                                    <div class="d-flex justify-content-center pb-2">{{ $t('wdw') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-2">
                                            <label for="wdw_1">
                                                {{ $t('time') }}
                                            </label>
                                            <div>
                                                <select
                                                    class="form-control"
                                                    v-model="selectedConditions['wdw']['update']['time']">
                                                    <option v-for="option in updateTimeOptions"
                                                            v-bind:value="option.value"
                                                            :selected="option.value == selectedConditions['wdw']['update']['time']">
                                                            {{ option.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-2">
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="wdw_update_odds_min">
                                                {{ $t('odds_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="wdw_update_odds_min"
                                                        name="wdw_update_odds_min"
                                                        v-model="selectedConditions['wdw']['update']['odds']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="wdw_update_odds_max"
                                                        name="wdw_update_odds_max"
                                                        v-model="selectedConditions['wdw']['update']['odds']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="wdw_3">
                                                {{ $t('stake_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="wdw_update_stake_min"
                                                        name="wdw_update_stake_min"
                                                        v-model="selectedConditions['wdw']['update']['stake']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="wdw_update_stake_max"
                                                        name="wdw_update_stake_max"
                                                        v-model="selectedConditions['wdw']['update']['stake']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    <div class="d-flex justify-content-center pb-2">{{ $t('asian_handicap') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-2">
                                            <label for="ah_1">
                                                {{ $t('time') }}
                                            </label>
                                            <div>
                                                <select
                                                    class="form-control"
                                                    v-model="selectedConditions['ah']['update']['time']">
                                                    <option v-for="option in updateTimeOptions"
                                                            v-bind:value="option.value"
                                                            :selected="option.value == selectedConditions['ah']['update']['time']">
                                                            {{ option.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-2">
                                            <label for="ah_1">
                                                {{ $t('line') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="text"
                                                    step="any"
                                                    id="ah_update_odds_line"
                                                    name="ah_update_odds_line"
                                                    v-model="selectedConditions['ah']['update']['line']"
                                                    class="form-control"
                                                    :disabled="true"
                                                    :placeholder="$t('line')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="ah_1">
                                                {{ $t('odds_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ah_update_odds_min"
                                                        name="ah_update_odds_min"
                                                        v-model="selectedConditions['ah']['update']['odds']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ah_update_odds_max"
                                                        name="ah_update_odds_max"
                                                        v-model="selectedConditions['ah']['update']['odds']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="ah_3">
                                                {{ $t('stake_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ah_update_stake_min"
                                                        name="ah_update_stake_min"
                                                        v-model="selectedConditions['ah']['update']['stake']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ah_update_stake_max"
                                                        name="ah_update_stake_max"
                                                        v-model="selectedConditions['ah']['update']['stake']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    <div class="d-flex justify-content-center pb-2">{{ $t('over_under') }}</div>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-12 col-md-2">
                                            <label for="ou_1">
                                                {{ $t('time') }}
                                            </label>
                                            <div>
                                                <select
                                                    class="form-control"
                                                    v-model="selectedConditions['ou']['update']['time']">
                                                    <option v-for="option in updateTimeOptions"
                                                            v-bind:value="option.value"
                                                            :selected="option.value == selectedConditions['ou']['update']['time']">
                                                            {{ option.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-2">
                                            <label for="ou_1">
                                                {{ $t('line') }}
                                            </label>
                                            <div>
                                                <input
                                                    type="text"
                                                    step="any"
                                                    id="ou_update_odds_line"
                                                    name="ou_update_odds_line"
                                                    v-model="selectedConditions['ou']['update']['line']"
                                                    class="form-control"
                                                    :disabled="true"
                                                    :placeholder="$t('line')"
                                                    :required="false"/>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="ou_1">
                                                {{ $t('odds_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ou_update_odds_min"
                                                        name="ou_update_odds_min"
                                                        v-model="selectedConditions['ou']['update']['odds']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ou_update_odds_max"
                                                        name="ou_update_odds_max"
                                                        v-model="selectedConditions['ou']['update']['odds']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-center">
                                            <label for="ou_3">
                                                {{ $t('stake_change_min_max') }}
                                            </label>
                                            <div class="d-flex flex-row">
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ou_update_stake_min"
                                                        name="ou_update_stake_min"
                                                        v-model="selectedConditions['ou']['update']['stake']['min']"
                                                        class="form-control"
                                                        :placeholder="$t('min_change')"
                                                        :required="false"/>
                                                </div>
                                                <div class="w-50">
                                                    <input
                                                        type="number"
                                                        step="any"
                                                        id="ou_update_stake_max"
                                                        name="ou_update_stake_max"
                                                        v-model="selectedConditions['ou']['update']['stake']['max']"
                                                        class="form-control"
                                                        :placeholder="$t('max_change')"
                                                        :required="false"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </form>
                    </template>
                    <template slot="footer">
                        <div class="w-100 d-flex justify-content-between">
                            <div class="form-group row" style="width: 50%;">
                                <label class="col-4 pt-3">{{ $t('send_updates') }}</label>
                                <app-input class="col-8 custom-fix-radio"
                                           type="radio"
                                           :list="sendUpdateOptions"
                                           v-model="sendUpdates"/>
                            </div>
                            <div class="d-flex">
                                <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal"
                                        @click="closeModal">
                                    {{ $t('close') }}
                                </button>
                                <button v-if="selectedRow.game_notifications == null" type="button"
                                        class="btn btn-primary" data-dismiss="modal" @click="saveCreateAlert">
                                    {{ $t('create_notification') }}
                                </button>

                                <button v-if="selectedRow.game_notifications != null" type="button"
                                        class="btn btn-danger mr-2" data-dismiss="modal" @click="deleteAlert">
                                    {{ $t('delete_notification') }}
                                </button>
                                <button v-if="selectedRow.game_notifications != null" type="button"
                                        class="btn btn-primary" data-dismiss="modal" @click="saveCreateAlert">
                                    {{ $t('update_notification') }}
                                </button>
                            </div>
                        </div>
                    </template>
                </app-modal>
                <app-modal v-if="confirmedModal"
                           modal-id="confirm-modal"
                           modal-alignment="center"
                           modal-size="md"
                           @close-modal="closeModal">
                    <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                        <div class="text-center">
                            <app-icon class="text-success text-center" :name="'check-circle'"/>
                        </div>
                        <h5 class="text-center font-weight-bold mt-4">{{ $t('congratulation') }}</h5>
                        <p class="text-center mb-primary p-0 font-size-90">{{ $t('confirm_text') }}</p>
                        <div class="text-center">
                            <a href="#" class="btn btn-success" data-dismiss="modal"
                               @click="closeModal">{{ $t('continue') }}</a>
                        </div>
                    </div>
                </app-modal>
                <app-modal v-if="alertModal"
                           modal-id="alert-modal"
                           modal-alignment="center"
                           modal-size="md"
                           @close-modal="closeModal">
                    <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                        <div class="text-center">
                            <app-icon class="text-warning" :name="'alert-triangle'"/>
                        </div>
                        <h5 class="text-center font-weight-bold mt-4">{{ $t('alert') + '!' }}</h5>
                        <p class="text-center mb-primary p-0  font-size-90">{{ $t('something_went_wrong') }}</p>
                        <div class="text-center">
                            <a href="#" class="btn btn-warning" data-dismiss="modal" @click="closeModal">
                                {{ $t('continue') }}
                            </a>
                        </div>
                    </div>
                </app-modal>
            </div>
        </div>
    </div>
</template>

<script>
import * as actions from "../../../../Config/ApiUrl";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";

export default {
    name: "index",
    mixins: [FormMixin],
    extends: CoreLibrary,
    props: ['sport'],
    data() {
        return {
            confirmedModal: false,
            alertModal: false,
            createAlertModal: false,
            selectedRow: null,
            alertConfigureUpdates: false,
            avgOddsOptions: [
                {
                    value: 10,
                    name: 10
                },
                {
                    value: 5,
                    name: 5
                },
            ],
            updateTimeOptions: [
                {
                    value: 0,
                    name: this.$t('last')
                },
                {
                    value: 1,
                    name: this.$t('1_minute')
                },
                {
                    value: 5,
                    name: this.$t('5_minutes')
                },
                {
                    value: 10,
                    name: this.$t('10_minutes')
                },
                {
                    value: 15,
                    name: this.$t('15_minutes')
                },
                {
                    value: 30,
                    name: this.$t('30_minutes')
                },
                {
                    value: 60,
                    name: this.$t('1_hour')
                },
                {
                    value: 1440,
                    name: this.$t('24_hours')
                }
            ],
            selectedConditions: {
                'wdw': {},
                'ah': {},
                'ou': {}
            },
            sendUpdateOptions: [
                {
                    id: 0,
                    value: this.$t('none')
                },
                {
                    id: 1,
                    value: this.$t('all')
                },
                {
                    id: 2,
                    value: this.$t('custom')
                }
            ],
            sendUpdates: 0,
            options: {
                id: 'sports-table',
                name: this.$t('sports_filter'),
                url: actions.BET_DATATABLE_DATA,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                enableSaveFilter: true,
                showDownload: true,
                columns: [
                    {
                        title: 'ID',
                        type: 'custom-html',
                        key: 'id',
                        modifier: (value, row) => {
                            return '<a href="/game/' + value + '" target="_blank">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('time'),
                        type: 'text',
                        key: 'event_start_time',

                    },
                    {
                        title: this.$t('sport'),
                        type: 'custom-html',
                        key: 'sport',
                        modifier: (value) => {
                            let sport = value.toLowerCase();
                            let response = '<div class="py-1 px-2 d-flex align-items-center">';
                            if (sport == 'basketball') {
                                response += '<img src="/images/sports/basketball.png" style="height: 15px; padding-right: 5px;">';
                            } else if (sport == 'tennis') {
                                response += '<img src="/images/sports/tennis.png" style="height: 15px; padding-right: 5px;">';
                            } else if (sport == 'football') {
                                response += '<img src="/images/sports/football.png" style="height: 15px; padding-right: 5px;">';
                            }
                            response += this.$t(sport);
                            response += '</div>';

                            return response;
                        }

                    },
                    /*{
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',

                    },*/
                    {
                        title: this.$t('team_1'),
                        type: 'custom-html',
                        key: 'team1',
                        modifier: (value, row) => {
                            return '<a href="/team/' + row.team_1_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('team_2'),
                        type: 'custom-html',
                        key: 'team2',
                        modifier: (value, row) => {
                            return '<a href="/team/' + row.team_2_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('league'),
                        type: 'custom-html',
                        key: 'league',
                        modifier: (value, row) => {
                            return '<a href="/league/' + row.league_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('wdw'),
                        type: 'wdw',
                        key: 'wdw',
                    },
                    {
                        title: this.$t('asian_handicap'),
                        type: 'ah',
                        key: 'asian',

                    },
                    {
                        title: this.$t('over_under'),
                        type: 'ou',
                        key: 'totals',

                    },
                    {
                        title: this.$t('action'),
                        type: 'action',
                    },
                ],
                actions: [
                    {
                        title: this.$t('favourite'),
                        icon: 'star',
                        type: 'none',

                    },
                    {
                        title: this.$t('alerts'),
                        icon: 'bell',
                        type: 'none',

                    },
                ],
                filters: [
                    {
                        "title": this.$t('start_date_range'),
                        "type": "range-picker",
                        "key": "start-time-range",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        "title": this.$t('sport'),
                        "type": "checkbox",
                        "key": "sport",
                        "option": [
                            {id: 'football', value: this.$t('football'), disabled: (this.sport == 'all' ? false : true)},
                            {id: 'basketball', value: this.$t('basketball'), disabled: (this.sport == 'all' ? false : true)},
                            {id: 'tennis', value: this.$t('tennis'), disabled: (this.sport == 'all' ? false : true)},
                        ],
                        "initValue": this.sport == 'all' ? null : this.sport,
                    },
                    {
                        "title": this.$t('wdw'),
                        "type": "odds-range-filter",
                        "key": "wdw",
                        "firstTitle": this.$t('home'),
                        "secondTitle": this.$t('draw'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('asian_handicap'),
                        "type": "odds-range-filter",
                        "key": "ah",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('home'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('over_under'),
                        "type": "odds-range-filter",
                        "key": "total",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('over'),
                        "thirdTitle": this.$t('under'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('sort_by'),
                        "type": "checkbox",
                        "key": "sort_by",
                        "option": [
                            {id: 'id', value: this.$t('ID')},
                            {id: 'date', value: this.$t('start_time')},
                            {id: 'wdw_1', value: this.$t('wdw_home')},
                            {id: 'wdw_2', value: this.$t('wdw_draw')},
                            {id: 'wdw_3', value: this.$t('wdw_away')},
                            {id: 'wdw_s', value: this.$t('wdw_stake')},
                            {id: 'ah_1', value: this.$t('ah_line')},
                            {id: 'ah_2', value: this.$t('ah_home')},
                            {id: 'ah_3', value: this.$t('ah_away')},
                            {id: 'ah_s', value: this.$t('ah_stake')},
                            {id: 'ou_1', value: this.$t('ou_line')},
                            {id: 'ou_2', value: this.$t('ou_over')},
                            {id: 'ou_3', value: this.$t('ou_under')},
                            {id: 'ou_s', value: this.$t('ou_stake')},
                            {id: 'odds_added', value: this.$t('odds_added_time')},
                            {id: 'wdw_added', value: this.$t('wdw_added_time')},
                            {id: 'ah_added', value: this.$t('ah_added_time')},
                            {id: 'ou_added', value: this.$t('ou_added_time')},
                            {id: 'odds_changed', value: this.$t('odds_changed_time')},
                            {id: 'wdw_changed', value: this.$t('wdw_changed_time')},
                            {id: 'ah_changed', value: this.$t('ah_changed_time')},
                            {id: 'ou_changed', value: this.$t('ou_changed_time')},
                            {id: 'stake_changed', value: this.$t('stake_changed')},
                            {id: 'wdw_stake_changed', value: this.$t('wdw_stake_changed')},
                            {id: 'ah_stake_changed', value: this.$t('ah_stake_changed')},
                            {id: 'ou_stake_changed', value: this.$t('ou_stake_changed')},
                        ],
                    },
                    {
                        "title": this.$t('order_asc_desc'),
                        "type": "checkbox",
                        "key": "order",
                        "option": [
                            {id: 'asc', value: this.$t('ASC')},
                            {id: 'desc', value: this.$t('DESC')},
                        ],
                    },
                    {
                        "title": this.$t('search_leagues'),
                        "type": "multi-search-select-filter",
                        "key": "league",
                        "url": actions.LEAGUES_LIST + '?sport=' + this.sport,
                    }
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 50,
                showAction: true,
                actionType: "default",
                autoRefresh: true,
                paginationOptions: [10, 25, 50, 100, 200],
                afterRequestSuccess: (res) => {
                    const params = new Proxy(new URLSearchParams(window.location.search), {
                        get: (searchParams, prop) => searchParams.get(prop),
                    });
                    if (this.sport != 'all' && typeof this.sport != 'undefined' && this.sport != params.sport) {
                        var url = window.location.href;
                        window.location.href = url + "?" + this.sport;
                    }
                }
            },
            comboActive: false,
            avgOdds: 10,
            responsiveDatatableInstruction: [],
        }
    },
    created() {
        this.searchAndSelectFilterOptions();
    },
    mounted() {
        this.comboActive = this.getCookie("comboActive") == 'true' ? true : false;
        this.avgOdds = this.getCookie("avgOdds") ? this.getCookie("avgOdds") : 10;
    },
    methods: {
        alertConfigureUpdatesToggle() {
            this.alertConfigureUpdates = !this.alertConfigureUpdates;
        },
        getAction(row, actionObj, active) {
            if (actionObj.title == this.$t('favourite')) {
                this.axiosGet(actions.GAME_FAVOURITE, {
                    params: {
                        id: row.id
                    }
                }).then(response => {
                    if (response.data == 1) {
                        row.favourites = {'game_id': row.id};
                        this.$toastr.s("<b>" + row.name + "</b><br/>" + this.$t('added_to_favourites'));
                    } else if (response.data == 0) {
                        row.favourites = null;
                        this.$toastr.w("<b>" + row.name + "</b><br/>" + this.$t('removed_from_favourites'));
                    } else {
                        this.$toastr.e(this.$t('something_went_wrong'));
                    }
                });
            } else if (actionObj.title == this.$t('alerts')) {
                var gamerow = $('#game' + row.id);
                this.selectedRow = row;
                if (row.game_notifications != null && row.game_notifications.conditions != null) {
                    this.selectedConditions = JSON.parse(row.game_notifications.conditions);
                } else {
                    let odds = JSON.parse(row['odds']);
                    this.selectedConditions = {
                        'wdw': {
                            '1': '',
                            '2': '',
                            '3': '',
                            's': '',
                            'update': {
                                'time': 0,
                                'odds': {
                                    'min': '',
                                    'max': ''
                                },
                                'stake': {
                                    'min': '',
                                    'max': '',
                                },
                            }
                        },
                        'ah': {
                            '1': '',
                            '2': '',
                            '3': '',
                            's': '',
                            'update': {
                                'time': 0,
                                'line': odds['asian']['line'],
                                'odds': {
                                    'min': '',
                                    'max': ''
                                },
                                'stake': {
                                    'min': '',
                                    'max': '',
                                },
                            }
                        },
                        'ou': {
                            '1': '',
                            '2': '',
                            '3': '',
                            's': '',
                            'update': {
                                'time': 0,
                                'line': odds['totals']['line'],
                                'odds': {
                                    'min': '',
                                    'max': ''
                                },
                                'stake': {
                                    'min': '',
                                    'max': '',
                                },
                            }
                        },
                    };
                }
                if (row.game_notifications != null) {
                    this.sendUpdates = row.game_notifications.send_updates;
                }
                if (row.game_notifications == null && gamerow.hasClass('game-notifications-row')) {
                    this.$toastr.e(this.$t('system_is_still_syncing'));
                } else if (row.game_notifications != null && !gamerow.hasClass('game-notifications-row')) {
                    this.$toastr.e(this.$t('system_is_still_syncing'));
                } else {
                    this.createAlertModal = true;
                }
            }
        },
        closeModal() {
            this.createAlertModal = false;
            this.confirmedModal = false;
            this.alertModal = false;
            this.alertConfigureUpdates = false;
        },
        deleteAlert() {
            var formData = new FormData();
            var gamerow = $('#game' + this.selectedRow.id);
            formData.append('game_id', this.selectedRow.id);
            this.createAlertModal = false;
            this.axiosPost({
                url: actions.GAME_NOTIFICATION_DELETE,
                data: formData,
            }).then(response => {
                if (response.data == 1) {
                    this.$toastr.w(this.$t('notification_deleted') + "<br/><b>" + this.selectedRow.name + "</b>");
                    if (gamerow) {
                        gamerow.removeClass('game-notifications-row');
                    }
                } else {
                    this.alertModal = true;
                }
            });
        },
        saveCreateAlert() {
            var form = $("#create-alert");
            var formData = new FormData();
            var conditions = {};
            var gamerow = $('#game' + this.selectedRow.id);
            formData.append('game_id', this.selectedRow.id);
            conditions['wdw'] = {
                '1': parseFloat(form.find('input[name="wdw[1]"]').val()),
                '2': parseFloat(form.find('input[name="wdw[2]"]').val()),
                '3': parseFloat(form.find('input[name="wdw[3]"]').val()),
                's': parseFloat(form.find('input[name="wdw[s]"]').val()),
                'update': this.selectedConditions['wdw']['update'],
            };
            conditions['ah'] = {
                '1': parseFloat(form.find('input[name="ah[1]"]').val()),
                '2': parseFloat(form.find('input[name="ah[2]"]').val()),
                '3': parseFloat(form.find('input[name="ah[3]"]').val()),
                's': parseFloat(form.find('input[name="ah[s]"]').val()),
                'update': this.selectedConditions['ah']['update'],
            };
            conditions['ou'] = {
                '1': parseFloat(form.find('input[name="ou[1]"]').val()),
                '2': parseFloat(form.find('input[name="ou[2]"]').val()),
                '3': parseFloat(form.find('input[name="ou[3]"]').val()),
                's': parseFloat(form.find('input[name="ou[s]"]').val()),
                'update': this.selectedConditions['ou']['update'],
            };
            formData.append('conditions', JSON.stringify(conditions));
            formData.append('send_updates', this.sendUpdates);
            this.createAlertModal = false;
            this.axiosPost({
                url: actions.GAME_NOTIFICATION_ADD,
                data: formData,
            }).then(response => {
                if (response.data == 1) {
                    this.$toastr.s(this.$t('notification_created') + "<br/><b>" + this.selectedRow.name + "</b>");
                    if (gamerow) {
                        gamerow.addClass('game-notifications-row');
                    }
                    this.alertConfigureUpdates = false;
                } else if (response.data == 2) {
                    this.$toastr.s(this.$t('notification_updated') + "<br/><b>" + this.selectedRow.name + "</b>");
                    this.alertConfigureUpdates = false;
                } else {
                    this.alertModal = true;
                }
            });
        },
        searchAndSelectFilterOptions() {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
        },
        saveComboStatus() {
            var newStatus = this.comboActive == true ? 'false' : 'true';
            this.setCookie("comboActive", newStatus, 30);
        },
        saveAvgOdds() {
            this.setCookie("avgOdds", this.avgOdds, 30);
            // reload table
            this.reloadTable();
        },
        setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        },
        getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        reloadTable() {
            location.reload();
        },
        downloadData() {
            let queryString = window.location.search;
            let requestUrl = '/' + actions.BET_DATATABLE_DATA + '/export/' + queryString;
            window.open(requestUrl, '_blank');
        },
    }

}
</script>